import { Navigate } from "react-router-dom";

export const MintUnavailablePage = () => <Navigate to="/nft" replace />;
